import axios from "axios";


const API = window["apiurl"];
// const API = "http://localhost:3000/";

export const setToken = token => {
  // TOKEN = token;
};

const TOKEN = () => {
  return localStorage.getItem("accessToken") || "";
};

const getAuthorizationHeader = () => {
  return {
    headers: {
      "x-access-token": TOKEN()

    },

  };
};

export const get = api => {
  return new Promise((resolve, reject) => {
    axios
      .get(API + api, getAuthorizationHeader())
      .then(resolve)
      .catch(reject);
  });
};

export const post = (api, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post(API + api, payload, getAuthorizationHeader())
      .then(resolve)
      .catch(reject);
  });
};

export const put = (api, payload) => {
  return new Promise((resolve, reject) => {
    axios
      .put(API + api, payload, getAuthorizationHeader())
      .then(resolve)
      .catch(reject);
  });
};

export const del = (api) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(API + api, getAuthorizationHeader())
      .then(resolve)
      .catch(reject);
  });
};

export const postFile = (api, payload) => {
  var bodyFormData = new FormData();
  bodyFormData.append('productPhoto', payload);
  let headers = getAuthorizationHeader()
  headers.headers['content-type'] = 'multipart/form-data'
  return new Promise((resolve, reject) => {
    axios
      .post(API + api, bodyFormData, headers)
      .then(resolve)
      .catch(reject);
  });
};

const utils = { setToken, get, post, put, del, postFile };

export default utils;
